export default "__VITE_ASSET__db690648__"